/* eslint-disable import/prefer-default-export */
export const SYSTEM_PERMISSION_LIST = [
  {
    guid: 'position', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/Xp1jlFAnOF.png?x-oss-process=image/quality,q_80', title: '位置信息', content: '获取位置信息，提供与地理位置相关的用车服务等信息。如扫码用车、打车、司机位置查询等。',
  },
  {
    guid: 'camera', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/jrQ_-dmfYi.png?x-oss-process=image/quality,q_80', title: '相机', content: '您可在开启相机/摄像头权限后使用该功能进行扫码用于登录、用车，拍摄照片或视频用于评价、分享，以及车主认证和其它特定场景下经您授权的人脸识别功能。',
  },
  {
    guid: 'album', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/matS9Tipit.png?x-oss-process=image/quality,q_80', title: '相册', content: '您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、发表评论/分享或与客服沟通提供证明功能。',
  },
  {
    guid: 'microphone', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/KyxGmZ4N6D.png?x-oss-process=image/quality,q_80', title: '麦克风', content: '您可在开启麦克风权限后使用麦克风语音录音功能，以便于实现与客服联系或与车主、车辆实现语音交互、开启安全保障需求。',
  },
  {
    guid: 'calendar', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/IaroEeQPfm.png?x-oss-process=image/quality,q_80', title: '日历', content: '在您开启我们可读取/写入您日历的权限后，我们将收集您的日历信息用于向您提供签到或领取权益相关记录及提醒。',
  },
  {
    guid: 'telephone', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/ecQ9qbUJwM.png?x-oss-process=image/quality,q_80', title: '拨打电话', content: '授权后，我们会读取本机识别码，用于保障您的账号与使用安全；在110报警、客服服务场景下，用于为您提供安全保障服务和客户服务。',
  },
  {
    guid: 'shear', icon: 'https://m.hellobike.com/resource/helloyun/wb15250/p2iB-Ttkjz.png?x-oss-process=image/quality,q_80', title: '剪切板', content: '在您开启我们可使用剪切板的权限后，您可以快捷复制礼品券券码、口令码，也可以复制订单号、服务号帐号，以便利地使用我们的服务。',
  },
];
